<span class="flag-icon flag-icon-{{countryCode}}"></span>
